import React, { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation, useParams } from "react-router";
import { Tabs } from "../../../components";
import {
  Container,
  InstanceName,
  NavWrapper,
  HeadWrapper
} from './styles'
import {
  Credentials,
  Defaults,
  RegionSettings,
  NotificationSettings,
  VolumeSettings
} from './components'


const OpenStack:FC = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  const {userId} = useParams()
  const [activeTab, setActiveTab] = useState<string>('1')
  const location = useLocation()
  useEffect(() => {
    const lastPathSegment = location.pathname.split('/').pop();
    tabs.forEach((item) => {
      if (lastPathSegment === item.slug) {
        setActiveTab(item.slug);
      }
    });
  }, [location]);
  const [tabs, setTabs] = useState<any[]>( [
    {
      title:t("CREDENTIALS"),
      slug:'credentials',
      id:'1'
    },
    {
      title:t("NOTIFICATIONS"),
      slug:'notifications',
      id:'2'
    },
    {
      title:t("DEFAULTS"),
      slug:'defaults',
      id:'3'
    },
    {
      title:t("VOLUME_SIZE_INCREMENTS"),
      slug:'volume-size-increments',
      id:'4'
    },
    {
      title:t("REGION_SETTINGS"),
      slug:'region-settings',
      id:'5'
    },
  ])

  // if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <HeadWrapper>
        <InstanceName>
          {t("OPENSTACK_SETTINGS")}
        </InstanceName>
      </HeadWrapper>
      <NavWrapper>
        <div>
          <Tabs
            tabs={tabs}
            size='display'
            blockNavigate
            location={activeTab}
            onChange={(e) => {
              navigate(`/settings/openstack/${e}`)
            }}
          />
        </div>
      </NavWrapper>
      <Routes>
        <Route path="/" element={<Navigate replace to="credentials" />} /> 
        <Route path='/credentials' element={<Credentials/>}/>
        <Route path='/defaults' element={<Defaults/>}/>
        <Route path='/region-settings' element={<RegionSettings/>}/>
        <Route path="/notifications" element={<NotificationSettings/>}/>
        <Route path="/volume-size-increments" element={<VolumeSettings/>}/>
      </Routes>
    </Container>
  )
}

export default OpenStack